import { Component, OnInit } from '@angular/core';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { LprDataService } from 'src/app/services/lpr-data.service';
import * as moment from 'moment';
import { BaseChartDirective } from 'ng2-charts';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(public toastrService: ToastrService, public lprdataservice: LprDataService, public excelExportDataService: ExcelExportDataService) { }

  public title: string = WebConstants.MENU_NAMES.DASHBOARD_ORG;
  public currentOrgStatsData: any;
  public currentOrgId: any;
  public orgData: any;
  public selected: {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public chart: BaseChartDirective;

  public chartData: any = [];
  public barChartLabels = [];
  public barChartLegend = true;
  public barChartType = 'bar';
  public barChartData = [
    {data: [], label: 'Shifts'},
    {data: [], label: 'Scans'},
    {data: [], label: 'Permitted'},
    {data: [], label: 'Authorized'},
    {data: [], label: 'Expired'},
    {data: [], label: 'Unauthorized'},
    {data: [], label: 'Unpaid'} 
  ];

  public barChartoption = {
    tooltips: {
      enabled: true
    },
    hover: {
      animationDuration: 1
    },
    animation: {
    duration: 1,
    onComplete: function () {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        // ctx.fillStyle = "rgba(255, 255, 255, 1)";
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
          });
        });
      }
    }
  };

  public paymentBarChartLabels = [];
  public paymentBarChartType = 'bar';
  public paymentBarChartLegend = true;
  public paymentBarChartData = [
    { data: [3365, 3359, 3380, 3381, 3356, 3355, 3640], label: 'Flowbird' },
    { data: [2028, 3348, 3340, 3319, 3386, 3327, 3390], label: 'Parkmobile' },
    { data: [2418, 3348, 3377, 339, 1030, 3327, 3340], label: 'Passport' }
  ];

  public paymentBarChartoption = {
    tooltips: {
      enabled: true
    },
    hover: {
      animationDuration: 1
    },
    animation: {
    duration: 1,
    onComplete: function () {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
          });
        });
      }
    }
  };

  public lineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartType = 'line';
  public lineChartLegend = true;
  public lineChartData = [
    { data: [65, 59, 60, 71, 53, 51, 90], label: 'Expired', fill: false },
    { data: [55, 39, 80, 81, 66, 59, 80], label: 'Unpaid', fill: false },
    { data: [15, 29, 70, 91, 59, 65, 70], label: 'Unautherized', fill: false }
  ];

  public lineChartOptions = {
    responsive: true,
    scales: {
      x: {
        type: 'category',
        labels: this.lineChartLabels,
      },
      y: {
        beginAtZero: true,
      }
    }
  };

  ngOnInit(): void {
  }

  excelSheetDownload(): void{

    if(!this.currentOrgStatsData){
      this.toastrService.error("No Data Found", "Failed To Export CSV!")
      return;
    }

    let dataForExcel = [];
  
    this.currentOrgStatsData.forEach((row: any) => {
      let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized, row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: "Monthly Shift Statistics",
      data: dataForExcel,
      headers: ['Date', 'Total Shifts', 'Total Scans', 'Total Permitted', 'Total Authorized', 'Total Expired', 'Total Unauthorized', 'Total Unpaid']
    };

    this.excelExportDataService.exportExcel(reportData)
  }

  downloadChartImage(event):void{

    if(!this.currentOrgStatsData){
      this.toastrService.error("No Data Found", "Failed To Export PNG!")
      return;
    }

    var anchor = event.target;
    anchor.href = document.getElementsByTagName('canvas')[0].toDataURL();
    anchor.download = "Monthly_Statistics.png";
  }

  selectOrg(orgId): void{
    this.currentOrgId = orgId;
  }

  searchOrgData(): void {

    if(!this.currentOrgId){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationData({
      "sessionStartString": this.selected.start.format("MM-DD-YYYY"),
      "sessionEndString": this.selected.end.format("MM-DD-YYYY"),
      "licencePlateNumber":"",
      "organizationId": this.currentOrgId
    });
  }
                            
  findCurrentOrganizationData(payload): void {
    this.lprdataservice.ShiftStatsDataMonthly(payload)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.currentOrgStatsData = response.data;
        this.setNewValuesToChart();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }

  setNewValuesToChart(): void {
    this.barChartLabels = [];
    this.barChartData = [
      {data: [], label: 'Shifts'},
      {data: [], label: 'Scans'},
      {data: [], label: 'Permitted'},
      {data: [], label: 'Authorized'},
      {data: [], label: 'Expired'},
      {data: [], label: 'Unauthorized'},
      {data: [], label: 'Unpaid'} 
    ];

    this.chartData = this.currentOrgStatsData
    console.log(this.chartData);

    for(let i=0; i<this.chartData.length; i++){
      this.barChartLabels[i] = this.chartData[i]['month'];

      this.barChartData[0].data[i] = this.chartData[i]['totalShifts']
      this.barChartData[1].data[i] = this.chartData[i]['totalScans']
      this.barChartData[2].data[i] = this.chartData[i]['totalPermitted']
      this.barChartData[3].data[i] = this.chartData[i]['totalAuthorized']
      this.barChartData[4].data[i] = this.chartData[i]['totalExpired']
      this.barChartData[5].data[i] = this.chartData[i]['totalUnauthorized']
      this.barChartData[6].data[i] = this.chartData[i]['totalUnpaid']
    }
   
    this.chart.chart.update();
  }

}
